import React, { Component } from 'react';

class Contact extends Component {

  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  getTranslatedContent(langCode){
    if(!["he", "en"].includes(langCode)){ // setting langCode to "en" if invalid code given
      langCode = "en";
    }
    var retVal;
    if(langCode === "he"){
      retVal = <>

        אנא צרו קשר בכל שאלה או הצעה בכתובת: <b>info@taryaganalytics.com</b>

      </>
    } else if (langCode === "en") {
      retVal = <>

        Please contact us with any questions or suggestions at: <b>info@taryaganalytics.com</b>

      </>
    }
    return retVal;
  }
  
  render() {
    return <>
      {this.getTranslatedContent(this.props.langCode)}
    </>
  }
}

export default Contact;